export default __webpack_public_path__ + "static/media/Subtract.6dd7e519.png";